// ================================
// STYLES
// ================================

import 'styles/index.scss';
import 'fullpage.js/dist/fullpage.min.css';

// ================================
// FULLPAGE.JS
// ================================

import fullpage from 'fullpage.js/dist/fullpage.min.js';
import LazyLoad from 'vanilla-lazyload/dist/lazyload.js';
var MobileDetect = require('mobile-detect');
// ================================
// WINDOW LAODED
// ================================

var md = new MobileDetect(window.navigator.userAgent);
var isIos = md.is('iPhone') || md.is('iPad')

console.log('IS IOS?', isIos)


window.onload = function () {
  var overlay = document.getElementById('overlay');
  overlay.style.display = 'none';

  var allVideos = document.getElementsByTagName('video');
  var $width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
  if ($width < 700) {
    for (var i = 0; i < allVideos.length; i++) {
      var $src = allVideos[i].getElementsByTagName('source')[0].src
      if (isIos) {
        allVideos[i].muted = true;
      }
      allVideos[i].getElementsByTagName('source')[0].src = $src.replace('.mp4', '_m.mp4');
    }
  }

  let fp = new fullpage('#fullpage', {
    verticalCentered: false,
  	css3: false,
    slidesNavigation: true,
  	sectionsColor: ['#222', '#222', '#222', '#222', '#222', '#222', '#222', '#222', '#222', '#222', '#222', '#222', '#222', '#222', '#222', '#222', '#222', '#222', '#222', '#222', '#222', '#222', '#222', '#222', '#222', '#222', '#222', '#222', '#222', '#222', '#222', '#222', '#222', '#222', '#222', '#222', '#222', '#222', '#222', '#222', '#222', '#222', '#222', '#222', '#222'],
  	navigation: true,
  	navigationPosition: 'right',
    navigationTooltips: ['Į viršų', '', '', '', '', '', '', '', '', '', 'Stebėti juodųjų gandrų – tyliai ir atsargiai ', '', '', '', '', '', 'Du lizdai – skirtingos istorijos', '', '', '', '', '', '', 'Iš miško neskrenda, tik lizdus keičia', '', '', '', '', '', '', '', '', '', 'Paslaptingi ir Lietuvoje labai reti', '', '', '', '', '', '', '', '', '', '', 'Pabaiga'],
  	showActiveTooltip: true,
    licenseKey: 'OPEN-SOURCE-GPLV3-LICENSE',
    scrollBar: false,
    touchSensitivity: 1,
    scrollingSpeed: 1150,
    autoScrolling: true
  });

  if ($width < 1000) {
    var msngr = document.getElementById('shareMessenger');
    msngr.href = 'fb-messenger://share/?link=https://www.lrytas.lt/multimedija/lietuva-stebuklas-po-atviru-dangumi/paslaptis-sengireje&app_id=1059833664058776';
  }

  var video = document.getElementsByClassName("video-section")[0];
  var percentageBar = document.getElementsByClassName("progress__inner")[0];

  video.addEventListener('timeupdate', function() {
    var currentPos = video.currentTime;
    var maxduration = video.duration;
    var percentage = 100 * currentPos / maxduration;
    percentageBar.style.width = percentage+'%'
  });

  var lazy = new LazyLoad({
      elements_selector: ".image"
  });

  var dots = document.querySelectorAll('#fp-nav ul li')

  for (var i = 0; i < dots.length; i++) {
    if (dots[i].childNodes.length <= 1) {
      dots[i].style.display = 'none';
    }
  }

  var scrollDown = document.getElementById('scrollDown');
  scrollDown.addEventListener('click', () => {
    fp.moveSectionDown();
  })

  var muteButtons = document.querySelectorAll('.button-mute');
  for (var i = 0; i < muteButtons.length; i++) {
  	muteButtons[i].addEventListener('click', function (ev) {
    	var $id = ev.target.getAttribute('data-mute')
      var $video = document.getElementById($id);
      if ($video.muted) {
        ev.target.classList.remove('active');
      	$video.muted = false;
      } else {
        ev.target.classList.add('active');
      	$video.muted = true;
      }
    })
  }

  // for (var i = 0; i < allVideos.length; i++) {
  //   if (allVideos[i].getAttribute('data-hidecontrols')) {
  //     allVideos[i].removeAttribute('controls');
  //   }
  // }
}

window.addEventListener("resize", function () {
  setTimeout(function () {
    fp.reBuild();
  }, 300)
}, false);

console.log('CACHE4545')
